import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'agl-two-pt-blocks',
  templateUrl: './two-pt-blocks.component.html',
  styleUrls: ['./two-pt-blocks.component.scss']
})
export class TwoPtBlocksComponent implements OnInit {

  @Input() color: string = "orange";
  // @Input() color: string = "newcol05";

  constructor() { }

  ngOnInit(): void {
  }

}
